import React from 'react'

export default function Sorting({ callApi, view, types, shortedName, tableName, setSortingNameOrderBy, setSortingTabType, tab, filterName }) {
    const sortTable = (type = 'asc') => {
        let name = {};
        if (tableName === "client" && shortedName === "created_at_order_by") {

            name["created_at_order_by"] = type;

            if (view === 'admin') {
                name["order"] = types;
            }

        } else if (tableName === "client" && shortedName === "volunteer_date_order_by") {

            name["volunteer_date_order_by"] = type;

            if (view === 'admin') {
                name["order"] = types;
            }

       
     } else {
            name["orderBy"] = type;
            if (view === 'admin') {
                name["order"] = types;
            }
        }
        if (setSortingNameOrderBy !== undefined) {
            setSortingTabType(tab)
            setSortingNameOrderBy(name);
        }
        if (filterName !== undefined && filterName == "free_zoom_session") {


            name = {

                orderBy: type,
                oprater: "=",
                field: 'free_zoom_session',
                value: 1,
            }
        }
        callApi(name);
    };
    return (
        <span className="d-inline-flex flex-column align-items-center sort-box" style={{ gap: '2px', marginLeft: '4px' }}>
            <svg onClick={() => sortTable('asc')} className="pointer" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', opacity: 0.5 }}>
                <path d="M1 5L5 1L9 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <svg onClick={() => sortTable('desc')} className="pointer" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', opacity: 0.5 }}>
                <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </span>
    )
}
